import { Component, Prop } from 'vue-property-decorator';
import { Button } from 'streamlabs-beaker';
import Base from '../Base';

@Component({
  components: {
    SButton: Button,
  },
})
export default class ConfirmationModal extends Base {
  onConfirmCallback: (callbackData?) => {} = null;
  callbackData: any = null;

  @Prop({ default: 'modal-confirmation' })
  name!: string;

  @Prop({ default: 400 })
  width!: number;

  @Prop({ default: 600 })
  minWidth!: number;

  @Prop()
  title!: string;

  @Prop()
  text!: string;

  @Prop({ default: 'Confirm' })
  confirmButtonText!: string;

  @Prop({ default: 'Cancel' })
  confirmSecondaryButtonText!: string;

  @Prop({ default: 'warning' })
  buttonVariation!: string;

  get modalMinWidth(): number {
    return this.minWidth < this.width ? this.minWidth : this.width;
  }

  onConfirmHandler() {
    this.$emit('confirm');
    this.$modal.hide(this.name);

    if (this.onConfirmCallback) this.onConfirmCallback(this.callbackData);
  }

  onCancelHandler() {
    this.$emit('cancel');
    this.$modal.hide(this.name);

    if (this.onConfirmCallback) this.onConfirmCallback(this.callbackData);
  }

  beforeClose() {
    this.$emit('beforeClose');
  }

  beforeOpen(data) {
    if (!data.params) return;
    this.onConfirmCallback = data.params.onConfirmCallback;
    this.callbackData = data.params.callbackData;
  }
}
